<template>
  <VLabel
    v-if="label || $slots.label"
    class="tw-mb-2"
    :for="htmlFor"
    html-tag="label"
    data-test-id="vLabel"
  >
    <template #default>
      <slot name="label">{{ label }}</slot>
    </template>
    <template v-if="labelAnnotation" #subLabel>
      {{ labelAnnotation }}
    </template>
  </VLabel>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import VLabel from '~/components/ui/VLabel.vue'

/**
 * Creates a label for an associated input.
 * It serves as a wrapper for VLabel with the `htmlTag` set to "label".
 */
export default defineComponent({
  name: 'LabelInput',
  components: {
    VLabel,
  },
  props: {
    /**
     * The "for" html attribute for the label element.
     */
    htmlFor: {
      type: String,
      required: true,
    },
    label: {
      type: [String, Number],
      required: false,
      default: '',
    },
    labelAnnotation: {
      type: [String, Number],
      required: false,
      default: '',
    },
  },
})
</script>
